import httpUserClient from '@/plugins/httpUserClient';

export default {
  index(currentPage, perPage) {
    return httpUserClient.get(`research/user/projects?page=${currentPage}&per_page=${perPage}`);
  },
  show(id) {
    return httpUserClient.get(`research/user/projects/${id}`);
  },
  create(activityId, data) {
    return httpUserClient.post(`research/user/activities/${activityId}/projects`, { research_project: { ...data } });
  },
  patch(id, data) {
    return httpUserClient.patch(`research/user/projects/${id}`, { research_project: { ...data } });
  },
  update(id, data) {
    return httpUserClient.patch(`research/user/projects/${id}`, { research_project: { ...data } });
  },
  stageShow(projectId, stageId) {
    return httpUserClient.get(`research/user/projects/${projectId}/stages/${stageId}`);
  },
  stagePatch(projectId, stageId, data) {
    return httpUserClient.patch(`research/user/projects/${projectId}/stages/${stageId}`, { research_stage: { ...data } });
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/userApis/research/api-project.js